import { IconButton } from '@mui/material'
import { getIconButtonStyles } from './MobileIconButton.styles'

export interface MobileIconButtonProps {
  iconName: string
  onClick: () => void
  colorType: 'primary' | 'secondary' | 'text'
  variant?: 'text' | 'contained'
  disabled?: boolean
}

function MobileIconButton({
  iconName,
  onClick,
  colorType,
  disabled = false,
  variant = 'contained'
}: MobileIconButtonProps) {
  const iconButtonStyles = getIconButtonStyles(colorType, variant)

  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      disableRipple
      sx={iconButtonStyles}
    >
      <i className={iconName} />
    </IconButton>
  )
}

export default MobileIconButton
